'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    text-align: center;\n'], ['\n    text-align: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

var _Radio = require('./Radio');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CenterTd = _styledComponents2.default.td(_templateObject);

var MatrixRow = function (_Component) {
    _inherits(MatrixRow, _Component);

    function MatrixRow() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MatrixRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MatrixRow.__proto__ || Object.getPrototypeOf(MatrixRow)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (value) {
            var _this$props = _this.props,
                type = _this$props.type,
                onChange = _this$props.input.onChange;


            onChange({ type: type, value: value });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MatrixRow, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                scale = _props.scale,
                row = _props.row,
                language = _props.language,
                _props$input = _props.input,
                name = _props$input.name,
                _props$input$value = _props$input.value,
                value = _props$input$value === undefined ? {} : _props$input$value,
                _props$meta = _props.meta,
                error = _props$meta.error,
                submitFailed = _props$meta.submitFailed,
                viewMode = _props.viewMode;


            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    (0, _experiumPlayerHelpersLegacy.getText)(row, language)
                ),
                scale.map(function (item, index) {
                    return _react2.default.createElement(
                        CenterTd,
                        { key: 'row-item-' + name + '-' + index },
                        _react2.default.createElement(_Radio.Radio, {
                            disabled: viewMode,
                            checked: item.id === value.value,
                            onChange: function onChange() {
                                return _this2.onChange(item.id);
                            },
                            showError: error && submitFailed })
                    );
                })
            );
        }
    }]);

    return MatrixRow;
}(_react.Component);

MatrixRow.propTypes = {
    scale: _propTypes2.default.array,
    row: _propTypes2.default.object,
    language: _propTypes2.default.string,
    input: _propTypes2.default.object,
    viewMode: _propTypes2.default.bool,
    type: _propTypes2.default.string,
    meta: _propTypes2.default.object.isRequired
};
exports.default = MatrixRow;